import dark from './dark';

const light = (params) => dark(params, false);

export default light;
